export const ADD_COURSE_BASIC_DETAILS = 'ADD_COURSE_BASIC_DETAILS';
export const ADD_COURSE_BASIC_DETAILS_SUCCESS = 'ADD_COURSE_BASIC_DETAILS_SUCCESS';

export const UPDATE_COURSE_BASIC_DETAILS = 'UPDATE_COURSE_BASIC_DETAILS';

export const GET_ACTIVE_GOALS = 'GET_ACTIVE_GOALS';
export const GET_ACTIVE_GOALS_SUCCESS = 'GET_ACTIVE_GOALS_SUCCESS';

export const GET_ACTIVE_COURSES = 'GET_ACTIVE_COURSES';
export const GET_ACTIVE_COURSES_SUCCESS = 'GET_ACTIVE_COURSES_SUCCESS';

export const GET_USER_SUGGESTIONS = 'GET_USER_SUGGESTIONS';
export const GET_USER_SUGGESTIONS_SUCCESS = 'GET_USER_SUGGESTIONS_SUCCESS';

export const GET_BULK_REPORT = 'GET_BULK_REPORT';
export const GET_BULK_REPORT_SUCCESS = 'GET_BULK_REPORT_SUCCESS';


export const STORE_GENERAL_SETTINGS = 'STORE_GENERAL_SETTINGS';

export const STORE_FAQ = 'STORE_FAQ';

export const STORE_SEO = 'STORE_SEO';

export const TREE_DATA_VIEW_SUCCESS = 'TREE_DATA_VIEW_SUCCESS';

export const SAVE_ADVANCED_SETTINGS = 'SAVE_ADVANCED_SETTINGS';

export const STORE_PACKAGE_ID = 'STORE_PACKAGE_ID';
export const ADD_COURSE_TEST_SERIES = 'ADD_COURSE_TEST_SERIES';

export const FETCH_EXISTING_SCHEDULED_TESTS = 'FETCH_EXISTING_SCHEDULED_TESTS';

export const FETCH_MAP_TEST_SUGGESTIONS = 'FETCH_MAP_TEST_SUGGESTIONS';

export const COURSES_BY_SCHEDULE_ID = 'COURSES_BY_SCHEDULE_ID';
export const FETCH_SCHEDULED_TESTS = 'FETCH_SCHEDULED_TESTS';

export const GET_BASIC_INFO = 'GET_BASIC_INFO';

export const SET_BULK_TEST_UPLOAD_DATA = 'SET_BULK_TEST_UPLOAD_DATA';

export const GET_COURSE_DETAILS = 'GET_COURSE_DETAILS';

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';

export const SAVE_TAB_DATA = 'SAVE_TAB_DATA';

export const PUBLISH_COURSE = 'PUBLISH_COURSE';

export const SAVE_ADVANCED_SETTING = 'SAVE_ADVANCED_SETTING'

export const SET_TEST_COUNT='SET_TEST_COUNT';

export const CHECK_ADVANCED_SETTINGS_MANDATORY_FIELDS = 'CHECK_ADVANCED_SETTINGS_MANDATORY_FIELDS';
export const FETCH_CONTENT_FROM_PACKAGES = 'FETCH_CONTENT_FROM_PACKAGES';
export const APPROVE_AND_PUBLISH = 'APPROVE_AND_PUBLISH';
export const REJECT_COURSE = 'REJECT_COURSE';
export const APPROVE_COURSE = 'APPROVE_COURSE';

